<template>
    <div class="link-dynamic-filter" :style="{width: width}">
        <component :is="type" :searchIcon="searchIcon" :dynamicFilter="value" @confirm="handleConfirm" ref="filter"/>
    </div>
</template>

<script>

    import {DYNAMIC_FILTER_TYPE, DynamicFilter} from "./link-dynamic-filter";
    import LinkDynamicFilterInput from "./types/link-dynamic-filter-input";
    import LinkDynamicFilterDate from "./types/link-dynamic-filter-date";
    import LinkDynamicFilterNumber from "./types/link-dynamic-filter-number";
    import LinkDynamicFilterLov from "./types/link-dynamic-filter-lov";

    window.DynamicFilter = DynamicFilter

    export default {
        name: "link-dynamic-filter",
        components: {LinkDynamicFilterLov, LinkDynamicFilterNumber, LinkDynamicFilterDate, LinkDynamicFilterInput},
        props: {
            value: {type: DynamicFilter, require: true},
            width: {type: String, default: '220px'},
            searchIcon: {type: Boolean},
        },
        computed: {
            type() {
                if (!this.value) return 'input'
                const type = DYNAMIC_FILTER_TYPE[this.value.type]
                if (!type) return 'input'
                return `link-dynamic-filter-${type}`
            },
        },
        methods: {
            handleConfirm(dynamicFilter) {
                this.$emit('change', dynamicFilter)
            },
            getValue() {
                this.$refs.filter.getValue()
            },
        }
    }
</script>

<style lang="scss">
    .link-dynamic-filter {
        & > div {
            width: 100% !important;

            .link-input {
                width: 100% !important;
            }
        }
    }
</style>